import HMOApi, {AI_TOKEN_USAGE} from "store/api/HMOApi";

export const AiTokenUsageApi = HMOApi.injectEndpoints({
    endpoints: (build) => ({
        getAiTokenUsage: build.query({
            query: () => ({
                url: "/ai-token-usage",
                method: "GET",
            }),
            providesTags: [AI_TOKEN_USAGE],
        }),
    }),
});

export const {
    useGetAiTokenUsageQuery,
} = AiTokenUsageApi;
